import { render, staticRenderFns } from "./GrupoUsuarioAdicionar.vue?vue&type=template&id=012a4d04&"
import script from "./GrupoUsuarioAdicionar.vue?vue&type=script&lang=js&"
export * from "./GrupoUsuarioAdicionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports